import { useState, useRef, useEffect } from "react";
import { ChevronDown } from "lucide-react";
import { statusOptions } from "../utils/data";

const Header = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [notificationOpen, setNotificationOpen] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);
  const [enabled, setEnabled] = useState(false);

  const [currentStatus, setCurrentStatus] = useState(statusOptions[0]);
  const dropdownRef = useRef(null);
  const notificationRef = useRef(null);
  const profileRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
      if (
        notificationRef.current &&
        !notificationRef.current.contains(event.target)
      ) {
        setNotificationOpen(false);
      }
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setProfileOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleStatusClick = () => {
    setDropdownOpen((prev) => !prev);
    setNotificationOpen(false);
  };

  const handleNotificationClick = () => {
    setNotificationOpen((prev) => !prev);
    setDropdownOpen(false);
  };

  const handleProfileClick = () => {
    setProfileOpen((prev) => !prev);
    setDropdownOpen(false);
  };

  const handleStatusSelect = (status) => {
    setCurrentStatus(status);
    setDropdownOpen(false);
  };

  return (
    <header className="z-10 mt-2 mb-2 relative w-full h-[48px] rounded-[12px] bg-[#00000014] px-4 py-2 flex items-center justify-between">
      {/* Left: Logo & Title */}
      <div className="flex items-center gap-3">
        <img
          src="/logo.png"
          alt="Logo"
          className="object-cover w-4 h-4 rounded-full md:w-8 md:h-8"
        />
        <h1 className="md:text-[14px] text-[10px] font-semibold text-black">
          Agent Dashboard
        </h1>
      </div>

      {/* Right: Status + Icons */}
      <div className="flex items-center gap-2 sm:gap-3">
        {/* Status dropdown */}
        <div className="relative" ref={dropdownRef}>
          <div
            onClick={handleStatusClick}
            className="cursor-pointer h-[32px] px-2 sm:px-3 flex items-center gap-2 bg-white rounded-[7px]"
          >
            <div
              className="w-[12px] h-[12px] rounded-full"
              style={{ backgroundColor: currentStatus.color }}
            />
            <span className="text-[10px] sm:text-[12px] font-semibold text-black">
              {currentStatus.label}
            </span>
            <ChevronDown className="w-4 h-4 text-black stroke-[2.5]" />
          </div>

          {dropdownOpen && (
            <div className="absolute right-0 z-50 w-[204px] rounded-[12px] bg-white shadow-md mt-2 p-3 flex flex-col gap-3">
              {statusOptions.map((status) => (
                <div
                  key={status.label}
                  onClick={() => handleStatusSelect(status)}
                  className="flex items-center justify-between cursor-pointer"
                >
                  <div className="flex items-center gap-2">
                    <div
                      className="w-[12px] h-[12px] rounded-full"
                      style={{ backgroundColor: status.color }}
                    />
                    <span className="text-[12px] font-medium text-black">
                      {status.label}
                    </span>
                  </div>
                  {currentStatus.label === status.label && (
                    <img src={status.icon} alt="selected" className="w-3 h-3" />
                  )}
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Notification Icon */}
        <div className="relative" ref={notificationRef}>
          <div
            className="w-6 h-6 cursor-pointer"
            onClick={handleNotificationClick}
          >
            <img
              src="/icons/Notification.png"
              alt="Notification"
              className="object-contain w-full h-full"
            />
          </div>

          {notificationOpen && (
            <div className="absolute right-0 z-50 w-[250px] rounded-[12px] bg-white shadow-md mt-2 p-3 flex flex-col gap-2">
              {/* First Notification */}
              <div className="bg-[#D9D9D9] rounded-[8px] px-2 py-1 flex flex-col gap-1">
                <div className="flex items-center justify-between">
                  <span className="text-[10px] font-inter text-black">
                    You received a mail from Julia
                  </span>
                  <span className="text-[8px] font-inter text-black">
                    recent
                  </span>
                </div>
              </div>

              {/* Second Notification */}
              <div className="bg-[#D9D9D957] rounded-[8px] px-2 py-1 flex flex-col gap-1">
                <span className="text-[10px] font-inter text-black">
                  Order is dispatched from buyer for return delivery
                </span>
                <span className="text-[8px] text-end  font-inter text-black">
                  2:30 pm
                </span>
              </div>
            </div>
          )}
        </div>

        {/* Profile */}
        {/* Profile */}
        <div className="relative" ref={profileRef}>
          <div
            onClick={handleProfileClick}
            className="w-[60px] h-[28px] bg-white rounded-full flex items-center justify-between px-1 cursor-pointer"
          >
            <img
              src="/icons/Profile-pic.png"
              alt="Profile"
              className="w-[28px] h-[28px] rounded-full bg-[#D9D9D9]"
            />
            <ChevronDown className="w-4 h-4 text-black stroke-[2.5]" />
          </div>

          {profileOpen && (
            <div className="absolute right-0 z-50 w-[180px] rounded-[12px] bg-white shadow-md mt-2 p-3 flex flex-col gap-2">
              <div className="flex flex-row items-start justify-between w-full pb-2 border-b border-black">
                <div className="flex flex-row">
                  <img
                    src={"/icons/Profile-pic.png"}
                    alt="icon"
                    className="w-[40px] h-[40px] object-contain"
                  />
                  <div className="flex flex-col w-full pl-2 mt-1">
                    <span className="text-[12px] font-inter font-semibold text-black">
                      James Wilson
                    </span>
                    <span className="text-[11px] font-inter text-[#00000073] text-opacity-80">
                      Senior Lead
                    </span>
                  </div>
                </div>
              </div>
              <div className="text-[12px] justify-between flex flex-row font-inter text-black cursor-pointer hover:underline">
                <span className="text-[12px] font-inter font-semibold text-black">
                  Settings
                </span>
                <img
                  src={"/icons/setting.png"}
                  alt="setting icon"
                  className="w-[18px] h-[18px] object-contain"
                />
              </div>
              <div className="flex items-center justify-between">
                <span className="text-[12px] font-inter font-semibold text-black">
                  DarkMode
                </span>
                <label className="relative inline-flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    checked={enabled}
                    onChange={() => setEnabled(!enabled)}
                    className="sr-only"
                  />
                  <div className="w-8 h-4 transition-colors duration-300 bg-gray-400 rounded-full shadow-inner"></div>
                  <div
                    className={`absolute w-4 h-4 bg-black rounded-full shadow top-0 left-0 transition-transform duration-300 ${
                      enabled ? "translate-x-4 bg-white" : ""
                    }`}
                  ></div>
                </label>
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
